import { HttpResult } from 'widgets-for-react'
import { ContactPerson } from '../../cmsPageState'
import { transformContactPersonData } from '../../sharepointPageApi/transformers/pageDataToPage'
import { ContactPersonData } from '../../sharepointPageApi/types/pageData'

export const contactPersonBlockApi = async (
  contactPersonId: number,
): Promise<HttpResult<ContactPerson>> => {
  const res = await fetch(
    `/api/v1/lists/contact-persons/${contactPersonId}`
  )

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status
    }

  const data: ContactPersonData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: transformContactPersonData(data)
  }
}
